import { useCallback, useContext, useEffect, useState } from "react";
import { BlockScopingContext } from "../../context/blockScoping";
import { UserInteractionContext } from "../../context/userInteraction";
const useSubscribeToUserInteraction = (filter, callback) => {
    const { subscribe, unsubscribe } = useContext(UserInteractionContext);
    useEffect(() => {
        subscribe(filter, callback);
        return () => unsubscribe(callback);
    }, [filter, callback]);
};
const usePublishUserInteraction = (component, interaction) => {
    if (component.includes(":") || interaction.includes(":"))
        console.warn(`Args to usePublishUserInteraction can't contain ":", ("${component}", "${interaction}")`);
    const { block } = useContext(BlockScopingContext);
    const { publish } = useContext(UserInteractionContext);
    const onUserInteraction = useCallback((additionalData) => publish(`${block}:${component}:${interaction}`, additionalData), [publish, block, component, interaction]);
    return [onUserInteraction];
};
const useSubscribeAndWaitForChange = (filter, callback, dependencies) => {
    const [waitingData, setWaitingData] = useState(null);
    const onPublish = useCallback((_topic, data) => {
        setWaitingData(data);
    }, [callback, setWaitingData]);
    useSubscribeToUserInteraction(filter, onPublish);
    useEffect(() => {
        if (waitingData !== null) {
            const result = callback(filter, { ...waitingData, ...dependencies });
            if (result)
                setWaitingData(null);
        }
    }, [setWaitingData, waitingData, ...Object.values(dependencies)]);
};
export { useSubscribeToUserInteraction, usePublishUserInteraction, useSubscribeAndWaitForChange };
